import { useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Form, Button, Row, Col, InputGroup } from "react-bootstrap";
import Loader from "../components/Loader";
import Message from "../components/Message";
import FormContainer from "../components/FormContainer";
import { register } from "../actions/userActions";

function collectPasswordIssues(nextPassword, nextConfirm) {
  if (!nextPassword && !nextConfirm) {
    return [];
  }
  const issues = [];
  if (nextPassword.length < 8) {
    issues.push("Password must be at least 8 characters.");
  }
  if (!/[A-Z]/.test(nextPassword)) {
    issues.push("Password must include 1 capital letter.");
  }
  if (!/[0-9]/.test(nextPassword)) {
    issues.push("Password must include 1 number.");
  }
  if (nextPassword !== nextConfirm) {
    issues.push("Passwords do not match.");
  }
  return issues;
}

function RegisterScreen() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [passwordIssues, setPasswordIssues] = useState([]);
  const dispatch = useDispatch();
  const userRegister = useSelector((state) => state.userRegister);
  const { loading, error, success, message } = userRegister;
  const errorList = Array.isArray(error) ? error : error ? [error] : [];

  const checkPasswords = (nextPassword, nextConfirm) => {
    setPasswordIssues(collectPasswordIssues(nextPassword, nextConfirm));
  };

  const submitHandler = (event) => {
    event.preventDefault();
    const issues = collectPasswordIssues(password, confirmPassword);
    setPasswordIssues(issues);
    if (issues.length || !password) {
      return;
    }
    dispatch(register(name, email, password));
  };

  return (
    <FormContainer centered>
      <h1>Register</h1>
      {success ? (
        <Message variant="success">{message}</Message>
      ) : (
        <>
          {errorList.map((item) => (
            <Message key={item} variant="danger">
              {item}
            </Message>
          ))}
          {passwordIssues.map((item) => (
            <Message key={item} variant="danger">
              {item}
            </Message>
          ))}
          {loading && <Loader />}
          <Form onSubmit={submitHandler}>
            <Form.Group controlId="name" className="mb-3">
              <Form.Label>Name</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Enter name"
                value={name}
                onChange={(event) => setName(event.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="email" className="mb-3">
              <Form.Label>Email Address</Form.Label>
              <Form.Control
                required
                type="email"
                placeholder="Enter email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="password" className="mb-3">
              <Form.Label>Password</Form.Label>
              <InputGroup>
                <Form.Control
                  required
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter password"
                  value={password}
                  onChange={(event) => setPassword(event.target.value)}
                  onKeyUp={(event) => checkPasswords(event.target.value, confirmPassword)}
                />
                <Button
                  variant="outline-secondary"
                  type="button"
                  onClick={() => setShowPassword((current) => !current)}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  <i className={`fa-solid ${showPassword ? "fa-eye-slash" : "fa-eye"}`}></i>
                </Button>
              </InputGroup>
              <Form.Text className="text-muted">
                A password must be at least 8 characters and include 1 capital letter and 1 number.
              </Form.Text>
            </Form.Group>
            <Form.Group controlId="passwordConfirm" className="mb-3">
              <Form.Label>Confirm Password</Form.Label>
              <InputGroup>
                <Form.Control
                  required
                  type={showConfirmPassword ? "text" : "password"}
                  placeholder="Confirm password"
                  value={confirmPassword}
                  onChange={(event) => setConfirmPassword(event.target.value)}
                  onKeyUp={(event) => checkPasswords(password, event.target.value)}
                />
                <Button
                  variant="outline-secondary"
                  type="button"
                  onClick={() => setShowConfirmPassword((current) => !current)}
                  aria-label={showConfirmPassword ? "Hide password" : "Show password"}
                >
                  <i className={`fa-solid ${showConfirmPassword ? "fa-eye-slash" : "fa-eye"}`}></i>
                </Button>
              </InputGroup>
            </Form.Group>
            <Button type="submit" variant="primary" disabled={loading}>
              Register
            </Button>
          </Form>
        </>
      )}
      <Row className="py-3">
        <Col>
          Have an account? <Link to="/login">Login</Link>
        </Col>
      </Row>
    </FormContainer>
  );
}

export default RegisterScreen;
